import { Injectable } from '@angular/core';
import {TranslateService, TranslatePipe } from '@ngx-translate/core';


@Injectable({ providedIn: 'root' })
export class MultilanguageService {
    constructor(private translate: TranslateService) {
     const SessionLan = sessionStorage.getItem('lang');
   //  translate.setDefaultLang(SessionLan);
   }
    public language: string;
    public isSearchAutoComplete = false;
  SetLanguage(langParams: string) {

     const SessionLan = sessionStorage.getItem('lang');
     this.language = langParams ? langParams : SessionLan;
     this.translate.setDefaultLang(this.language);
    }

    // getLanguage(){
    //     let SessionLan = sessionStorage.getItem("lang");
    //     return this.language ? this.language : SessionLan;
    // }
}
